import React, { useState } from 'react';
import { Button, Input } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Alert from '../Common/Modal/Alert';
import * as monitorActions from '../../store/aiConversationMonitor/actions';

/**
 * The emergency brake: every conversation of the country, or of one agent,
 * back to the call center at once and nobody told. The page shows it to
 * administrators only, and the callable refuses it to anyone else.
 */
const StopAllButton = ({ agents }) => {
  const [confirm, setConfirm] = useState(false);
  const [agentId, setAgentId] = useState('');
  const acting = useSelector((state) => state.AiConversationMonitor.acting);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleConfirm = () => {
    dispatch(monitorActions.stopAllAiConversations(agentId));
    setConfirm(false);
    setAgentId('');
  };

  return (
    <>
      <Button
        color="danger"
        outline
        size="sm"
        className="mr-2"
        disabled={acting}
        onClick={() => setConfirm(true)}
      >
        <i className="bx bx-stop-circle font-size-14 align-middle mr-1"></i>
        {t('Stop every conversation')}
      </Button>
      <Alert
        isOpen={confirm}
        title={t('Stop every conversation of the agent?')}
        confirmBtnLabel={t('Stop them')}
        onCancel={() => setConfirm(false)}
        onConfirm={handleConfirm}
        dependencies={[agentId]}
      >
        <p>
          {t(
            'Every conversation of this country, or of the agent chosen, goes back to the call center and the agent stops writing. Nobody is told on WhatsApp. Use it when something is going wrong.',
          )}
        </p>
        <Input
          type="select"
          value={agentId}
          onChange={(event) => setAgentId(event.target.value)}
        >
          <option value="">{t('All agents')}</option>
          {agents.map(({ id, name }) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </Input>
      </Alert>
    </>
  );
};

export default StopAllButton;
